import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'

const url = 'v1/data'
const plural = 'csvs'
const single = 'csv'

const cdi = new ApiCore({
	create: true,
	url: url,
	plural: plural,
	single: single,
})

axios.defaults.timeout = 30000;

cdi.push = (id, payload, options, version) => {
	const encodedId = encodeURIComponent(id)
	const path = version
		? `v1/data/push/${encodedId}/${encodeURIComponent(version)}`
		: `v1/data/push/${encodedId}`
	return axios
		.post(`${apiProvider.BASE_URL}/${path}`, payload, options)
		.then(handleResponse)
		.catch(handleError);
}

cdi.pull = (id, payload, options, version) => {
	const encodedId = encodeURIComponent(id)
	const path = version
		? `v1/data/pull/${encodedId}/${encodeURIComponent(version)}`
		: `v1/data/pull/${encodedId}`
	return axios
		.post(`${apiProvider.BASE_URL}/${path}`, payload, options)
		.then(handleResponse)
		.catch(handleError);
}

export default cdi
